import { createFileRoute, redirect } from '@tanstack/react-router'

import { OrganizationAdmin } from '~/components/authorize/OrganizationAdmin'
import { isApiKeysEnabled } from '~/constants/featureFlag'
import { ApiKeyEdit } from '~/pages/ApiKeys/edit'

const ApiKeyEditPage: React.FC = () => {
  const { apiKeyId } = Route.useParams()
  return (
    <OrganizationAdmin thorwError>
      <ApiKeyEdit apiKeyId={apiKeyId} />
    </OrganizationAdmin>
  )
}

export const Route = createFileRoute('/_authenticated/api_keys/$apiKeyId/edit')(
  {
    beforeLoad: () => {
      if (!isApiKeysEnabled) {
        // redirect() は throw して使うのが TanStack Router の作法
        throw redirect({ to: '/' })
      }
    },
    component: ApiKeyEditPage,
  },
)
